// extracted by mini-css-extract-plugin
module.exports = {"gif":"y_bL","gif--wrapped":"y_bM"};